import { AllCardsType } from '../data/all-cards'

/** Género gramatical del nombre de la carta en español rioplatense. */
export const getCardGrammaticalGender = (name: string): 'm' | 'f' => {
    const n = (name || '').trim()
    if (!n) return 'm'

    // Mayores / nombres que ya traen artículo
    if (/^La\b/i.test(n)) return 'f'
    if (/^El\b/i.test(n)) return 'm'

    // Figuras de la corte
    if (/^Sota\b/i.test(n) || /^Reina\b/i.test(n)) return 'f'
    if (/^Caballero\b/i.test(n) || /^Rey\b/i.test(n)) return 'm'

    // Numerales y As → masculino (el Dos, el As, …)
    return 'm'
}

/**
 * Nombre listo para el prompt, con artículo correcto y
 * "invertido/invertida" acordado al género de la carta.
 *
 * Ej: "la Sota de Copas invertida", "el Dos de Espadas invertido", "El Mago invertido"
 */
export const formatCardLabel = (card: Pick<AllCardsType, 'name' | 'position'>): string => {
    const raw = (card.name || '').trim()
    if (!raw) return ''

    const gender = getCardGrammaticalGender(raw)
    const hasArticle = /^(El|La)\b/i.test(raw)
    const labeled = hasArticle ? raw : `${gender === 'f' ? 'la' : 'el'} ${raw}`

    if (card.position !== 'invertida') return labeled
    return `${labeled} ${gender === 'f' ? 'invertida' : 'invertido'}`
}
